import React, {useState} from 'react';
import { useRouteNode } from 'react-router5';
import Tab from "../../components/tab/tab";
import Briefing from "../singleView/briefing";
import Themes from "../singleView/themes";
import Reseaux from "../singleView/reseaux";
import Entities from "../singleView/entities";
import { AffiliationView } from "../singleView/shared";
import {setFocusContact, setNotifyContact} from "../../api";
import {useTranslation} from "react-i18next";
import {toRichText} from "../../utils/text";
import { Timeline } from 'react-twitter-widgets'

import '../style/contact_profil.css'

function settings_is_focused(id, focus) {
  return (focus[id] || {}).focus_enabled;
}

function settings_is_notification(id, focus) {
  return (focus[id] || {}).notification_enabled;
}

function ContactView({contact, getEntityRoute, getContactRoute, component_route, onClose}){
  const { t } = useTranslation();
  const { route } = useRouteNode(component_route);
  let { data, name, params} = route;

  const heightScreen = window.innerHeight;

  name = component_route === name ? `${name}.briefing` : name;

  // add {} because of return false below
  const {id, img, biography, career, firstname, lastname,
	 extra_data, links_backward, links_forward} = contact || {};

  const [focus_checked, setFocusChecked] = useState(
    settings_is_focused(id, data.focus_contact || {})
  );
  const [notification_checked, setNotificationChecked] = useState(
    settings_is_notification(id, data.focus_contact || {})
  );

  // useRouteNode may be called even w/ route that does not match? before re-render?
  if (! name.startsWith(component_route)) { return false; };

  const getContactRouteDefault = (contact) => [component_route, {id: contact.id}]
  // assumes we just need to replace last component route to have new route for entity component
  const getEntityRouteDefault = (entity) => [component_route.replace(/contact$/, "entity"), {id: entity.id}]

  let view;
  let user_img;

  if(img === undefined || img === null){
    user_img = <span className="c-profil_img-replace">{firstname[0].toUpperCase()}{lastname[0].toUpperCase()}</span>
  }else{
    user_img = <img alt="" className="c-profil_img" style={{width: "50px", height: "50px"}} src={img} />
  }

  const route_no_tab = name.split('.').slice(0, -1).join('.')

  const tabContent = [
    {"title": "Briefing", "root": `${route_no_tab}.briefing`},
    {"title": "Biography", "root": `${route_no_tab}.biography`},
    {"title": "Réseaux", "root": `${route_no_tab}.reseaux`},
    {"title": "Entités", "root": `${route_no_tab}.entities`},
    {"title": "Thèmes", "root": `${route_no_tab}.themes`},
  ].map(x => {
    return {...x, params, options: {replace: true}};
  });

  function setContactFocus({id}){
    setFocusChecked(!focus_checked);
    setFocusContact(id, focus_checked ? "unset" : "set");
  }
  function setContactNotification({id}){
    setNotificationChecked(!notification_checked);
    setNotifyContact(id, notification_checked ? "unset" : "set");
  }

  const [tab] = name.split('.').reverse();

  if(tab === "briefing"){
    view = <Briefing data={data} root={"contact"}/>;
  }else if(tab === "biography"){
    view = <div className="c-container_data">
      <p className="c-data_bio">{toRichText(biography)}</p>
      { career && <div>
	<h3>{t("Career")}</h3>
	<p className="c-data_career">{toRichText(career)}</p>
	</div>
      }
     </div>;
  }else if(tab === "reseaux"){
    view = <>
      <div className="c-container_data">
        <Reseaux links_backward={links_backward} links_forward={links_forward}
                 getRoute={getContactRoute || getContactRouteDefault} />
      </div>
    </>
  }else if(tab === "entities"){
    view = <>
      <div className="c-container_data">
        <Entities links_backward={links_backward} links_forward={links_forward}
                  getRoute={getEntityRoute || getEntityRouteDefault} />
      </div>
    </>
  }else if(tab === "themes"){
    view = <Themes dataList={data} focus={data.focus_theme} route={"contact"}/>;

  }else if(tab === "twitter"){
    if(extra_data.url_twitter){
      view = <div className={'lapin'}>
        <div className={'twitterFeedContainer'}>
          <Timeline
              dataSource={{
                sourceType: 'profile',
                screenName: extra_data.url_twitter
              }}
              options={{
                height:heightScreen - (heightScreen * (30/100)),
              }}
          />
        </div>
      </div>
    }else{
      view = <div className={'lapin'}>
        <div className={'twitterFeedContainer'}>
        </div>
      </div>
    }

  }else if(tab === "facebook"){
    const elem =document.querySelector('#facebook-script')
    if(elem) {
      elem.parentNode.removeChild(elem);
    }
      const script = document.createElement("script");
      script.src = "https://connect.facebook.net/fr_FR/sdk.js#xfbml=1&version=v12.0&appId=1886632064925817&autoLogAppEvents=1";
      script.async = true;
      script.id = 'facebook-script';
      document.body.appendChild(script);

    const src = "https://www.facebook.com/plugins/page.php?href="+extra_data.url_facebook+"&tabs=timeline&width=500&height=500&small_header=true&adapt_container_width=true&hide_cover=true&show_facepile=true&appId";
    view = <div>
      <iframe
          src={src}
           width={500} height="450"  scrolling="no" frameBorder="0"
          allowFullScreen={true}
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
    </div>;
  }else if(tab === "linkedin"){
    if(extra_data.url_linkedin !== null ){
      view = <div className="container-linkedin">
        <a className="c-showedit_validate_button linkedin_button" target="_blank" href={extra_data.url_linkedin}>
          {t('Voir sur linkedin')}
        </a>
      </div>
    }
  }

  return (
    <>
      <div className="c-profil_resume contact">
        <div className="c-resume_img">
          { user_img }
          <div className="c-img_buttons">
            { onClose && <span className="c-button_bar-back-icon" onClick={onClose} /> }
            <span className={`c-button_notification ${notification_checked ? 'active' : ''}`} onClick={() => setContactNotification({id})}></span>
            <span className={`c-button_focus ${focus_checked ? 'active' : ''}`} onClick={() => setContactFocus({id})}></span>
          </div>
        </div>
        <div className="c-resume_infos">
          <span className="c-infos_name">{firstname} {lastname}</span>
          <span className="c-infos_affiliation"><AffiliationView affiliations={data.contact.affiliations} /></span>
          <span className="c-infos_mandat">{extra_data.full_mandat}</span>
          <p className="c-infos_bio">{toRichText(biography)}</p>
        </div>
      </div>
      <div className="c-profil_authorFeed contact">
        <div className="c-container_menu">
          <Tab active={tabContent.map(x => x.root).indexOf(name)}>
            {tabContent.map((tab, idx) => (
                <Tab.TabPane key={`Tab-${idx}`} tab={tab.title} root={tab.root} params={tab.params} options={tab.options} />
              ))
            }
          </Tab>
        </div> {/*menu  Tabs */}
            {view}{/*<UserPostFeed user={user} bookmarks={bookmarksInit}/>*/}
      </div>
    </>
  );
}

export default ContactView
